$(document).ready(function() {

  //on variant change
  if($('.product-bundle').length > 0){

    //proper gold
    if($('body').hasClass('template-product-proper-bundle-gold')){
      if($('.bundle-option-drawer').length > 0){
        $('.bundle-option-drawer').find('.bundle-main-content .bundle-filter-container .filter-options-row button').each(function(){
          var filter_text = $(this).find('span').text().toLowerCase();
          console.log(filter_text);
          if(filter_text == 'gold'){
            $(this).addClass('active');
          }
        });
      }
    }
    //proper gold
    
    $(document).on('change','.product__info-container variant-radios fieldset input',function(){
      let get_count = $(this).attr('data-slot-number');
      let count = parseInt(get_count, 10);
      let htmlContent = ''; // Initialize HTML content

      const get_index = $(this).attr('data-index');
      if($('.value-stack .free-box-packs-wrap .pair-wrap').length > 0){
        if(get_index == 1){
          $('.value-stack .free-box-packs-wrap .pair-wrap').removeClass('pair-selected');
          $('.value-stack .free-box-packs-wrap .pair-wrap:first').addClass('pair-selected');
        }else if(get_index == 2){
          $('.value-stack .free-box-packs-wrap .pair-wrap').removeClass('pair-selected');
          $('.value-stack .free-box-packs-wrap .pair-wrap:lt(2)').addClass('pair-selected');
        }else if(get_index == 3){
          $('.value-stack .free-box-packs-wrap .pair-wrap').removeClass('pair-selected');
          $('.value-stack .free-box-packs-wrap .pair-wrap:lt(3)').addClass('pair-selected');
        }else if(get_index ==4){
          $('.value-stack .free-box-packs-wrap .pair-wrap').addClass('pair-selected');
        }
      }

        // Generate HTML for each option
        for (let i = 1; i <= count; i++) {
          htmlContent += `
            <div class="options">
              <div class="options-inner" data-index="${i}">
                <div class="option-image">
                  <img src="" width="" height="" style="display:none;">
                  <div class="bundle-image-close hidden"> 
                    <button type="button" class="absolute right-4 top-4 rounded border border-black-200 bg-white p-6 hover:shadow">
                      <svg class="" width="11" height="11" viewBox="0 0 20 20" fill="none">
                        <path d="M18.75 18.75L1.25 1.25M18.75 1.25L1.25 18.75" stroke="#121212" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </button>
                  </div>
                  <div class="plus-svg-icon">
                    <svg class="" width="13" height="13" viewBox="0 0 10 10" fill="none">
                      <path d="M5 0.5V9.5M9.5 5H0.5" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                </div>
                <span class="option-title">Design ${i}</span>
              </div>
            </div>
          `;
        }

      // Append the generated HTML to .bundle-options-lists
      $('.bundle-options .bundle-options-lists').html(htmlContent);
    });
  }

  //click on design options click
  $(document).on('click','.options-inner', function(){
    
    $('.bundle-option-drawer').addClass('active-open');
    $(".section-header").removeClass(".shopify-section-header-hidden");
    var index = $(this).attr('data-index');
    $('.bundle-option-drawer .bundle-drawer-heading h4.drawe_main_heading').html('Choose your design '+index);
    $('.bundle-option-drawer').attr('data-index',index);
    $('.bundle-main-search-bar').removeClass('main');
    $('.no-results').hide();
    $('.bundle-drawer-products-grid .bundle-pro-lists .bundle-pro').removeClass('hidden');

    if($('body').hasClass('template-product-proper-bundle-gold')){
      applyFiltersAndSearch();
      $('.bundle-option-drawer .bundle-filter-container').addClass('filter-cust-open');
      $('.bundle-main-search-bar').removeClass('main');
    }
  });

  //remove product from design on close icon
  $(document).on('click','.options-inner .bundle-image-close', function(event){
    event.stopPropagation();
    $(this).siblings('img').attr('src','');
    $(this).siblings('img').hide();
    var index = $(this).parents('.options-inner').attr('data-index');
    $(this).parents('.options-inner').find('.option-title').html('Design '+index);
    $(this).parents('.options-inner').find('.option-var-title').remove();
    $(this).parents('.options-inner').removeAttr('data-var-id');
    $(this).parents('.options-inner').removeClass('selected');
    $(this).addClass('hidden');

    const design_length = $('.bundle-options .bundle-options-lists .options').length;
    const sel_design_length = $('.bundle-options .bundle-options-lists .options .options-inner.selected').length;

    if(design_length != sel_design_length){
      var btn_text = $('.product-form__submit .cart_txt').attr('data-load-bundle-text');
      if(btn_text){
        $('.product-form__submit .cart_txt').html(btn_text);
      }
      $('.product-form__submit .price').addClass('hidden');
      $('.product-form__submit .cart-divider').addClass('hidden');
    }
  });

  //close drawer on outside click
  $(document).mouseup(function(e){
      var container = $(".bundle-option-drawer");
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.bundle-option-drawer').removeClass('active-open');
        // $('.quick-view-drawer').removeClass('quick-drawer-open');
      }
  });

  //close drawer on close button
  $(".close-bundle-drawer").click(function(){
      $('.bundle-option-drawer').removeClass('active-open');
      // $('.quick-view-drawer').removeClass('quick-drawer-open');
  });

  //filter search open close
  $(document).on('click','.bundle-option-drawer .bundle-drawer-heading .bundle-search-filter button', function(event){
     var target = $(this).attr('data-target');

     if(target == 'search'){
       $('.bundle-filter-container').removeClass('filter-cust-open');
       $('.bundle-main-search-bar').toggleClass('main');
     }else{
       $('.bundle-main-search-bar').removeClass('main');
       $('.bundle-filter-container').toggleClass('filter-cust-open');
     }
  });

  //filter applied
  // const filterButtons = $(".bundle-option-drawer .bundle-filter-container button");
  // const targetDivs = $(".bundle-pro-lists .bundle-pro"); // Replace ".target-div" with the selector for the divs you want to show/hide.
  // // const noResultsMessage = $(".no-results");
  // const $noResultsMessage = $("<div class='no-results' style='text-align:center;'>No Results Found</div>").hide().appendTo(".bundle-drawer-products-grid");

  // filterButtons.on("click", function () {
  //   const $button = $(this);
  //     $noResultsMessage.hide();
    
  //   $button.toggleClass("active");

  //   const activeValues = $(".bundle-filter-container button.active span")
  //     .map(function () {
  //       return $(this).text().trim();
  //     })
  //     .get();

  //   if (activeValues.length === 0) {
  //     targetDivs.removeClass("hidden");
  //       $noResultsMessage.hide();
  //   } else {
  //      let hasMatches = false;
  //     targetDivs.each(function () {
  //       const $div = $(this);
  //       const colorData = $div.data("color") ? $div.data("color").split(",") : [];
  //       const effectData = $div.data("effect") ? $div.data("effect").split(",") : [];

  //       const matches = activeValues.some((value) => colorData.includes(value) || effectData.includes(value));
        
  //       if (matches) {
  //         $div.removeClass("hidden");
  //          hasMatches = true;
  //       } else {
  //         $div.addClass("hidden");
  //       }
  //     });
  //     if (!hasMatches) {
  //       console.log('hiifff')
  //         $noResultsMessage.show();
  //     } else {
  //       console.log('hii')
  //         $noResultsMessage.hide();
  //     }
  //   }
  // });


  // //search functionality
  // const $searchInput = $(".product-search");
  // const $searchButton = $(".bundle-main-search-bar .btn");
  // const $bundleProDivs = $(".bundle-pro");
  // // const $noResultsMessage = $("<div class='no-results' style='text-align:center;'>No Results Found</div>").hide().appendTo(".bundle-drawer-products-grid");

  // function performSearch() {
  //   const searchText = $searchInput.val().trim().toLowerCase();

  //   if (searchText === "") {
  //     $bundleProDivs.removeClass("hidden");
  //     $noResultsMessage.hide();
  //   } else {
  //     let hasResults = false;

  //     $bundleProDivs.each(function () {
  //       const $bundleProTitle = $(this).find(".bundle-pro-title span"); // Find the title inside the div
  //       const titleText = $bundleProTitle.text().trim().toLowerCase();
        
  //       if (titleText.includes(searchText)) {
  //         $(this).removeClass("hidden");
  //         hasResults = true;
  //       } else {
  //         $(this).addClass("hidden"); 
  //       }
  //     });

  //     // Show or hide the no-results message based on search results
  //     if (hasResults) {
  //       $noResultsMessage.hide();
  //     } else {
  //       $noResultsMessage.show();
  //     }
  //   }
  // }

  // // Trigger search on button click
  // $searchButton.on("click", function (e) {
  //   e.preventDefault(); // Prevent default form submission behavior
  //   performSearch();
  // });

  // // Optional: Trigger search on Enter key press in the search input
  // $searchInput.on("keypress", function (e) {
  //   if (e.key === "Enter") {
  //     e.preventDefault(); // Prevent form submission
  //     performSearch();
  //   }
  // });

    // filter applied
  const filterButtons = $(".bundle-option-drawer .bundle-filter-container button");
  const targetDivs = $(".bundle-pro-lists .bundle-pro"); // Replace ".target-div" with the selector for the divs you want to show/hide
  const $noResultsMessage = $("<div class='no-results' style='text-align:center;'>No Results Found</div>").hide().appendTo(".bundle-drawer-products-grid");
  
  function applyFiltersAndSearch() {
    const activeValues = $(".bundle-filter-container button.active span")
      .map(function () {
        return $(this).text().trim();
      })
      .get();
  
    const searchText = $(".product-search").val().trim().toLowerCase();
  
    let hasMatches = false;
  
    targetDivs.each(function () {
      const $div = $(this);
      const colorData = $div.data("color") ? $div.data("color").split(",") : [];
      const effectData = $div.data("effect") ? $div.data("effect").split(",") : [];
      const titleText = $div.find(".bundle-pro-title span").text().trim().toLowerCase();
  
      // Check if the div matches both active filters and the search term
      const matchesFilter = activeValues.some((value) => colorData.includes(value) || effectData.includes(value));
      const matchesSearch = titleText.includes(searchText);

      console.log('activeValues',activeValues)
      console.log('matchesFilter',matchesFilter)
  
      if ((activeValues.length === 0 || matchesFilter) && (searchText === "" || matchesSearch)) {
        $div.removeClass("hidden");
        hasMatches = true;
      } else {
        $div.addClass("hidden");
      }
    });
  
    // Show or hide the no-results message based on filter and search results
    if (hasMatches) {
      $noResultsMessage.hide();
    } else {
      $noResultsMessage.show();
    }
  }
  
  // Handle filter button click
  filterButtons.on("click", function () {
    const $button = $(this);
    $button.toggleClass("active");
    applyFiltersAndSearch(); // Apply filters and search when filter is clicked
  });
  
  // Handle search functionality
  const $searchButton = $(".bundle-main-search-bar .btn");
  const $searchInput = $(".product-search");
  
  $searchButton.on("click", function (e) {
    e.preventDefault(); // Prevent default form submission behavior
    applyFiltersAndSearch(); // Apply filters and search when search button is clicked
  });
  
  $searchInput.on("keypress", function (e) {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission
      applyFiltersAndSearch(); // Apply filters and search on Enter key press
    }
  });



  //on product click
  $(document).on('click','.bundle-option-drawer .bundle-pro-lists .bundle-pro .group_btn', function(event){
    if (!event.target.closest('.bundle-pro-variant')) {
      var pro_img_url = $(this).find('.pro-image img').attr('src');
      var pro_title = $(this).find('.bundle-pro-title span').html();
      var pro_variant_title = $(this).find('.bundle-pro-variant span').html();
      var pro_var_id = $(this).parents('.bundle-pro').attr('data-var-id');
      var design_index = $('.bundle-option-drawer').attr('data-index');
    
      $('.bundle-options-lists .options-inner[data-index="'+design_index+'"]').find('.option-image img').attr('src',pro_img_url);
      $('.bundle-options-lists .options-inner[data-index="'+design_index+'"]').find('.option-image img').show();
      $('.bundle-options-lists .options-inner[data-index="'+design_index+'"]').find('.option-title').html(pro_title);
      $('.bundle-options-lists .options-inner[data-index="'+design_index+'"]').attr('data-var-id',pro_var_id);
      $('.bundle-options-lists .options-inner[data-index="'+design_index+'"] .bundle-image-close').removeClass('hidden');
      $('.bundle-options-lists .options-inner[data-index="'+design_index+'"]').addClass('selected');
      $(".close-bundle-drawer").trigger('click');
      $('.bundle-options-lists .options-inner[data-index="'+design_index+'"] .option-var-title').remove();
      $('.bundle-options-lists .options-inner[data-index="'+design_index+'"]').append('<span class="option-var-title">'+pro_variant_title+'</span>');
  
      const design_length = $('.bundle-options .bundle-options-lists .options').length;
      const sel_design_length = $('.bundle-options .bundle-options-lists .options .options-inner.selected').length;
  
      if(design_length == sel_design_length){
        var btn_text = $('.product-form__submit .cart_txt').attr('data-ori-bundle-text');
        if(btn_text){
          $('.product-form__submit .cart_txt').html(btn_text);
        }
        $('.product-form__submit .price').removeClass('hidden');
        $('.product-form__submit .cart-divider').removeClass('hidden');
        $('.product-form__submit .cart_btn_arrow').removeClass('hidden');
        
      }
    }
  });

  $(document).on('click','.bundle-option-drawer .bundle-pro-lists .bundle-pro .group_btn .bundle-pro-variant', function(event){
    console.log('clicked')
    $(this).parents('.pro-details').find('.quick-view').trigger('click');
  });

  //all product quick view button
  $(document).on('click','.quick-view',function(){
     // Parse the JSON data from the script tag
      const productsData = JSON.parse(document.getElementById('products-data').textContent);
    console.log(productsData);
      var pro_id = $(this).parents('.bundle-pro').attr('data-pro-id');
      var var_id = $(this).parents('.bundle-pro').attr('data-var-id');
      var var_color_title = $(this).parents('.bundle-pro').attr('data-color');
  
      // const matchedProduct = productsData.find(product => product.id === pro_id);
    const matchedProduct = productsData.find(product => product.id === Number(pro_id));
      if (matchedProduct) {
        console.log('Matched Product:', matchedProduct);
           if(matchedProduct.title){
             $('.quick-view-drawer .quick-view-products-detials .quick-title-description h4').html(matchedProduct.title);
           }else{
             $('.quick-view-drawer .quick-view-products-detials .quick-title-description h4').html('');
           }

          if(var_color_title){
            $('.quick-view-drawer .quick-view-products-detials .quick-title-description p.variant_name').html(var_color_title);
          }else{
            $('.quick-view-drawer .quick-view-products-detials .quick-title-description p.variant_name').html('');
          }
        
           // if(matchedProduct.description){
           //   $('.quick-view-drawer .quick-view-products-detials .quick-title-description .quick-pro-description').html(matchedProduct.description);
           // }else{
           //   $('.quick-view-drawer .quick-view-products-detials .quick-title-description .quick-pro-description').html(' ');
           // }
  
          if(matchedProduct.images){
            $('.quick-view-drawer .quick-view-products-detials .quick-pro-images .quick-pro-images-slider').html('');
             const productHtml = `<div class="quick-pro-images-slider-inner">${matchedProduct.images.map(image => `<div class="pro-image"><img height="" width="" src="${image}" alt="${matchedProduct.title}"></div>`).join('')}</div>`;
            $('.quick-view-drawer .quick-view-products-detials .quick-pro-images .quick-pro-images-slider').html(productHtml);
          }else{
            $('.quick-view-drawer .quick-view-products-detials .quick-pro-images .quick-pro-images-slider').html('');
          }
    
           $('.quick-view-drawer').addClass('quick-drawer-open');
           $('.quick-view-drawer').attr('data-pro-id',var_id);
          
          if ($('.quick-pro-images-slider-inner').hasClass('slick-initialized')) {
            $(".quick-pro-images-slider-inner").slick('unslick'); // Destroy the slider
          }
          $(".quick-pro-images-slider-inner").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            prevArrow: '<button class="slide-arrow prev-arrow"><svg class="" width="12" height="12" viewBox="0 0 18 16" fill="none"><path d="M8.4375 14.75L1.6875 8L8.4375 1.25M2.625 8H16.3125" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
            nextArrow: '<button class="slide-arrow next-arrow"><svg class="rotate-180" width="12" height="12" viewBox="0 0 18 16" fill="none"><path d="M8.4375 14.75L1.6875 8L8.4375 1.25M2.625 8H16.3125" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'
          });
      }
  });

  //back btn of quick view drawer
  $(document).on('click','.quick-view-drawer button.quick-view-backbtn',function(){
    $('.quick-view-drawer').removeClass('quick-drawer-open');
  });

  //in quick view drawer button click event
  $(document).on('click','.quick-view-drawer .quick-inner-details .quick-title-description .quick-pro-button',function(){
    var pro_id = $(this).parents('.quick-view-drawer').attr('data-pro-id');
    $('.bundle-option-drawer .bundle-pro-lists .bundle-pro[data-var-id="'+pro_id+'"] .group_btn').trigger('click');
     $('.quick-view-drawer').removeClass('quick-drawer-open');
  });

  //bundle pro button click
  $(document).on('click','.product-form .bundle-pro-template',function(event){
    event.preventDefault();
    event.stopPropagation();
    var $this = $(this);

    let main_title = $('product-info div.product__title h1').text();
    const design_length = $('.bundle-options .bundle-options-lists .options').length;
    const sel_design_length = $('.bundle-options .bundle-options-lists .options .options-inner.selected').length;
    if(design_length != sel_design_length){
      $('.bundle-options .bundle-options-lists .options .options-inner:not(.selected):first').trigger('click');
    }else{
      $($this).addClass('loading');
      $($this).find('.loading-overlay__spinner').removeClass('hidden');
      var timestamp = Math.round(new Date().getTime()/1000);
      var main_var_id = $('.product-form [name="id"]').val();
      let arrPdp = [];

      console.log(main_title);
      $('.bundle-options .bundle-options-lists .options').each(function(){
        var variant_id = $(this).find('.options-inner').attr('data-var-id');
        console.log(main_title);
        arrPdp.push({id: variant_id, quantity:1,"properties" : {"_bundle_sub_product":"yes","Part of":main_title,"_bundle_time": timestamp}});
      });

       if($('.value-stack .free-box-packs-wrap .pair-wrap.pair-fourth').hasClass('pair-selected')){
         var free_pro_id = $('.value-stack .free-box-packs-wrap .pair-wrap.pair-fourth').attr('data-free-product');
         if(free_pro_id){
           arrPdp.push({id: free_pro_id, quantity:1,"properties" : {"_bundle_sub_product":"yes","Part of":main_title,"_bundle_time": timestamp}});
         }
       }

      if(main_var_id){
        arrPdp.push({id: main_var_id, quantity:1,"properties" : {"_bundle_main_product":"yes","_bundle_time": timestamp}});
      }

      
      console.log(arrPdp);

      function addToCart(items) {
          // Send AJAX request to Shopify's cart/add.js
          $.ajax({
              url: '/cart/add.js',
              type: 'POST',
              dataType: 'json',
              data: { items: items },
              success: function(response) {
                $($this).removeClass('loading');
                $($this).find('.loading-overlay__spinner').addClass('hidden');
                 $.ajax({
                    url: window.location.href,
                    method: "GET",
                    dataType: "html",
                    success: function(htmlContent) {
                        let doc = new DOMParser().parseFromString(htmlContent, "text/html");
                        let cartDrawerElement = doc.querySelector("#CartDrawer .drawer__inner");
                        cartDrawerElement && ($("#CartDrawer .drawer__inner").replaceWith(cartDrawerElement.outerHTML))
                      // $('.m-cart-drawer--inner').removeClass('al-loading-bar loading al-loading-overlay overlay-show');
                        $("body").addClass("overflow-hidden"), $("cart-drawer.drawer").removeClass("is-empty"), $("cart-drawer.drawer").addClass("active");

                                     jQuery.getJSON('/cart.js', function(cart) {
                                       if(cart.item_count > 0){
                                          if($(".cart-count-bubble").length > 0)
                                          {
                                            $(".cart-count-bubble span:first").html(cart.item_count);
                                            $(".cart-count-bubble span.visually-hidden").html(cart.item_count+" items");
                                          }
                                            else
                                          {
                                            var html = "<div class='cart-count-bubble'><span aria-hidden='true'>"+ cart.item_count +"</span><span class='visually-hidden'>"+ cart.item_coun +"items</span></div>";
                                            // $(".header__icon--cart svg path").eq(3).remove();
                                            $(html).insertAfter(".header__icon--cart span");
                                          }
                                       }else{
                                         $(".cart-count-bubble").hide();
                                       }
                                      });
                    },
                    error: function(error) {
                        console.error("Error fetching and modifying HTML:", error)
                    }
                });
              },
              error: function(error) {
                 $($this).removeClass('loading');
                $($this).find('.loading-overlay__spinner').addClass('hidden');
                  console.error('Error adding to cart:', error);
              }
          });
      }
      
      // Call the function with the array of products
      addToCart(arrPdp);
      
    }
    
  });
 
});








